module.exports = __webpack_public_path__ + "img/dash.a5ed9a95.svg";